/* global axios */
import ApiClient from './ApiClient';

class CampaignContactsAPI extends ApiClient {
  constructor() {
    super('campaign_contacts', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new CampaignContactsAPI();
